import autosize from 'autosize';
import React, { useState, useEffect, useRef } from 'react';
import { HiOutlineCheck, HiOutlineTrash } from "react-icons/hi2";
import { TbPencil } from 'react-icons/tb';


const InstagramComents = ({ comment, user_image, integration, company, network, user_name, updateComment, deleteComment, isEditable }) => {
    const [commentText, setCommentText] = useState(comment.text || "");
    const [isEditing, setIsEditing] = useState(!comment.saved);
    const textareaRef = useRef(null);

    useEffect(() => {
        setCommentText(comment.text || "");
    }, [comment.text]);

    const handleCommentChange = (e) => {
        const newText = e.target.value;
        setCommentText(newText);
    };

    const handleSaveComment = () => {
        if (commentText.trim() === "") {
            return;
        }
        updateComment(commentText);
        setIsEditing(false);
    };

    useEffect(() => {
        if (textareaRef.current) autosize(textareaRef.current);
    }, [textareaRef.current, isEditing]);

    return (
        <div className="px-4 pb-4">
            <div className="flex items-start">
                <img src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} className="h-8 w-8 rounded-full mr-3" alt="User" />
                <div className="flex-1">
                    <p className="text-sm">
                        <span className="font-semibold mr-2">{user_name || integration?.name || company?.name}</span>
                        <div className="flex items-center">
                            {isEditing ? (
                                <textarea
                                    ref={textareaRef}
                                    className="text-tertiary-700 dark:text-gray-300 bg-transparent border-none focus:outline-none flex-grow"
                                    value={commentText}
                                    placeholder="Write a comment!"
                                    onChange={handleCommentChange}
                                    autoFocus
                                    onBlur={() => handleSaveComment()}
                                />
                            ) : (
                                <span 
                                    className="group text-tertiary-700 dark:text-gray-300 flex-grow cursor-pointer"
                                    onClick={() => isEditable && setIsEditing(true)}
                                >
                                    <span className='group-hover:!bg-tertiary-100 dark:group-hover:!bg-tertiary-900 whitespace-pre-wrap'>
                                        {commentText}
                                    </span>
                                    {isEditable && (
                                        <TbPencil className="text-tertiary-600 ml-0.5 hidden group-hover:inline-block -translate-y-[1px]" />
                                    )}
                                </span>
                            )}
                            

                            {isEditable && (
                                <div className="flex items-center">
                                    <button
                                        className="text-red-500 hover:text-red-600 ml-2"
                                        onClick={deleteComment}
                                    >
                                        <HiOutlineTrash className="h-5 w-5" />
                                    </button>
                                </div>
                            )}
                        </div>
                    </p>
                    <div className="flex items-center text-xs text-tertiary-500 dark:text-gray-400 dark:text-gray-400 mt-1">
                        <span className="mr-3">0d</span>
                        <span className="mr-3">0 likes</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InstagramComents;